var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightGraphic = function SvgRightGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 598,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 466.56c55.081 0 99.733-25.098 99.733-56.058 0-30.961-44.652-56.059-99.733-56.059-55.082 0-99.734 25.098-99.734 56.059 0 30.96 44.652 56.058 99.734 56.058Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M364.995 361.934c10.564 5.973 24.379-36.412 29.181-29l-.221 72.538c-1.626 13.025-11.23 25.834-28.96 35.765-38.933 21.877-102.098 21.877-141.031 0-19.503-10.938-29.181-25.331-29.181-39.651v-63.831c4.876-6.908 131.279 2.303 170.212 24.179Z",
    fill: "url(#right_graphic_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 389.784c55.081 0 99.733-25.098 99.733-56.059 0-30.96-44.652-56.058-99.733-56.058-55.082 0-99.734 25.098-99.734 56.058 0 30.961 44.652 56.059 99.734 56.059Z",
    fill: "url(#right_graphic_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 387.625c55.081 0 99.733-25.098 99.733-56.059 0-30.96-44.652-56.058-99.733-56.058-55.082 0-99.734 25.098-99.734 56.058 0 30.961 44.652 56.059 99.734 56.059Z",
    fill: "url(#right_graphic_svg__c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M294.516 373.593c41.291 0 74.764-18.816 74.764-42.026 0-23.211-33.473-42.026-74.764-42.026-41.29 0-74.763 18.815-74.763 42.026 0 23.21 33.473 42.026 74.763 42.026Z",
    fill: "url(#right_graphic_svg__d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.516 361.287c29.173 0 52.822-13.306 52.822-29.721 0-16.414-23.649-29.72-52.822-29.72-29.172 0-52.821 13.306-52.821 29.72 0 16.415 23.649 29.721 52.821 29.721Z",
    fill: "url(#right_graphic_svg__e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 323.435c64.221 0 116.282-29.287 116.282-65.414s-52.061-65.414-116.282-65.414-116.282 29.287-116.282 65.414 52.061 65.414 116.282 65.414Z",
    fill: "#09BFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 316.454c57.407 0 103.944-26.161 103.944-58.433s-46.537-58.433-103.944-58.433c-57.407 0-103.945 26.161-103.945 58.433s46.538 58.433 103.945 58.433Z",
    fill: "url(#right_graphic_svg__f)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M353.987 72.43v118.306c0-8.563-5.836-17.127-17.435-23.675-23.271-13.098-60.948-13.098-84.145 0-11.599 6.548-17.435 15.112-17.435 23.675V72.43c0-8.563 5.836-17.127 17.435-23.676 23.271-13.097 60.948-13.097 84.145 0 11.673 6.55 17.435 15.113 17.435 23.676Z",
    fill: "#09BFFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M363.296 38.68v136.8c0-9.931-6.723-19.79-20.168-27.346-26.892-15.112-70.405-15.112-97.296 0-13.446 7.556-20.168 17.487-20.168 27.346V38.68c0-9.931 6.722-19.79 20.168-27.346 26.891-15.112 70.404-15.112 97.296 0 13.445 7.484 20.168 17.415 20.168 27.346Z",
    fill: "url(#right_graphic_svg__g)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.891 132.662v53.612c-10.565 1.224-21.72.216-31.176-2.95-3.103-1.008-6.058-2.303-8.718-3.814-8.57-4.822-12.854-11.154-12.854-17.487v-53.324c.147 6.189 4.432 12.449 12.854 17.127 2.29 1.295 4.728 2.375 7.388 3.31l1.33.432c9.456 3.31 20.611 4.318 31.176 3.094Z",
    fill: "#09BFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M288.311 87.686v41.522c-2.586-.935-5.098-2.015-7.388-3.31-8.422-4.749-12.707-10.938-12.854-17.127V107.907c.295-6.116 4.58-12.161 12.854-16.839 2.364-1.367 4.802-2.447 7.388-3.382Z",
    fill: "#09BFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M394.915 260.108c-1.625 13.169-11.377 26.05-29.181 36.053-39.229 22.092-102.911 22.092-142.139 0-19.651-11.01-29.403-25.475-29.403-39.939V99.92c0 14.464 9.825 28.929 29.403 39.939 39.228 22.092 102.91 22.092 142.139 0 17.878-10.003 27.63-22.956 29.181-36.053v156.302Z",
    fill: "url(#right_graphic_svg__h)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M383.907 237.152c-1.403 11.73-10.121 23.172-26.004 32.095-34.944 19.646-91.607 19.646-126.625 0-17.509-9.859-26.226-22.74-26.226-35.621V176.2c0 12.881 8.717 25.762 26.226 35.621 34.944 19.646 91.607 19.646 126.625 0 15.883-8.923 24.601-20.437 26.004-32.095v57.426Z",
    fill: "url(#right_graphic_svg__i)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M347.56 137.34a54.85 54.85 0 0 1-4.581 2.375v52.748a253.948 253.948 0 0 0 4.581-2.375c14.627-8.203 22.606-18.782 23.862-29.504v-52.749c-1.256 10.795-9.235 21.301-23.862 29.505ZM238.961 157.49c-15.662-8.78-23.493-20.366-23.493-31.952v51.525c0 11.586 7.831 23.1 23.493 31.952 6.427 3.598 13.741 6.476 21.498 8.635v-51.525c-7.757-2.087-15.071-4.965-21.498-8.635Z",
    fill: "#09BFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M238.961 225.71c-3.768-2.159-7.092-4.39-9.973-6.837v4.318c2.881 2.375 6.205 4.678 9.973 6.836 6.427 3.599 13.741 6.477 21.498 8.636v-4.318c-7.757-2.159-15.071-5.037-21.498-8.635ZM238.961 216.067c-3.768-2.159-7.092-4.39-9.973-6.837v4.318c2.881 2.375 6.205 4.678 9.973 6.837 6.427 3.598 13.741 6.476 21.498 8.635v-4.318c-7.757-2.159-15.071-5.037-21.498-8.635Z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.696 597.971c24.44 0 44.252-11.148 44.252-24.899 0-13.751-19.812-24.899-44.252-24.899s-44.252 11.148-44.252 24.899c0 13.751 19.812 24.899 44.252 24.899Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M216.946 546.158c4.728 2.662 10.786-16.192 12.928-12.881l-.074 32.167c-.739 5.757-5.023 11.442-12.854 15.903-17.287 9.715-45.287 9.715-62.5 0-8.644-4.821-12.928-11.226-12.928-17.558v-28.282c2.142-3.166 58.141.936 75.428 10.651Z",
    fill: "url(#right_graphic_svg__j)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.696 558.535c24.44 0 44.252-11.147 44.252-24.899 0-13.751-19.812-24.898-44.252-24.898s-44.252 11.147-44.252 24.898c0 13.752 19.812 24.899 44.252 24.899Z",
    fill: "url(#right_graphic_svg__k)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.696 557.6c24.44 0 44.252-11.148 44.252-24.899 0-13.751-19.812-24.899-44.252-24.899s-44.252 11.148-44.252 24.899c0 13.751 19.812 24.899 44.252 24.899Z",
    fill: "url(#right_graphic_svg__l)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M185.696 551.339c18.32 0 33.171-8.344 33.171-18.638 0-10.294-14.851-18.638-33.171-18.638s-33.171 8.344-33.171 18.638c0 10.294 14.851 18.638 33.171 18.638Z",
    fill: "url(#right_graphic_svg__m)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M185.696 545.87c12.934 0 23.419-5.896 23.419-13.169 0-7.273-10.485-13.169-23.419-13.169-12.934 0-23.419 5.896-23.419 13.169 0 7.273 10.485 13.169 23.419 13.169Z",
    fill: "#09BFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M175.501 541.121c-1.921-1.152-3.176-2.519-3.694-3.886-.221-.576-.369-1.152-.369-1.728v-.072c0-2.086 1.404-4.173 4.285-5.685 5.614-3.022 14.701-2.806 20.168.432 2.807 1.655 4.137 3.814 4.063 5.901 0 .576-.147 1.152-.443 1.727-.591 1.368-1.921 2.663-3.841 3.742-5.689 3.023-14.702 2.807-20.169-.431Z",
    fill: "url(#right_graphic_svg__n)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913,
    d: "M170.995 529.75c-2.808-1.655-4.581-3.598-5.393-5.613-.296-.791-.518-1.655-.518-2.446v-.072c0-3.023 2.069-5.973 6.206-8.204 8.127-4.39 21.203-4.102 29.108.576 4.063 2.374 5.984 5.469 5.836 8.491-.074.864-.222 1.655-.591 2.447-.887 2.015-2.734 3.886-5.615 5.397-8.126 4.39-21.129 4.102-29.033-.576Z",
    fill: "url(#right_graphic_svg__o)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M166.414 518.452c-3.62-2.159-5.984-4.677-7.018-7.34-.443-1.079-.665-2.159-.665-3.238v-.072c0-3.958 2.734-7.844 8.127-10.723 10.638-5.685 27.703-5.325 38.046.792 5.319 3.094 7.831 7.124 7.609 11.082-.073 1.08-.295 2.159-.812 3.239-1.182 2.59-3.62 5.109-7.314 7.052-10.564 5.685-27.556 5.325-37.973-.792Z",
    fill: "url(#right_graphic_svg__p)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.738,
    d: "M161.908 507.082c-4.507-2.662-7.388-5.829-8.644-9.067-.517-1.295-.812-2.662-.812-3.958v-.144c0-4.893 3.324-9.643 10.047-13.241 13.15-7.052 34.205-6.62 46.985.936 6.502 3.886 9.678 8.851 9.457 13.673a11.471 11.471 0 0 1-.961 4.03c-1.477 3.238-4.432 6.26-9.013 8.707-13.224 7.052-34.278 6.62-47.059-.936Z",
    fill: "url(#right_graphic_svg__q)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M157.401 495.712c-5.319-3.166-8.791-6.908-10.269-10.794-.591-1.583-.96-3.166-.96-4.75v-.144c0-5.757 3.989-11.513 11.894-15.759 15.662-8.348 40.706-7.844 55.925 1.151 7.757 4.606 11.524 10.507 11.229 16.336-.074 1.583-.443 3.238-1.182 4.749-1.699 3.886-5.319 7.484-10.786 10.363-15.588 8.419-40.632 7.844-55.851-1.152Z",
    fill: "url(#right_graphic_svg__r)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.564,
    d: "M152.821 484.414c-6.206-3.67-10.195-7.988-11.968-12.521-.739-1.799-1.108-3.67-1.108-5.469v-.216c0-6.693 4.654-13.385 13.815-18.279 18.173-9.715 47.207-9.139 64.937 1.368 9.013 5.325 13.372 12.161 13.003 18.926a14.873 14.873 0 0 1-1.33 5.541c-1.995 4.461-6.132 8.635-12.485 12.089-18.1 9.571-47.134 8.996-64.864-1.439Z",
    fill: "url(#right_graphic_svg__s)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.476,
    d: "M148.314 473.044c-7.018-4.174-11.598-9.139-13.593-14.32-.813-2.087-1.256-4.174-1.256-6.261v-.216c0-7.628 5.245-15.184 15.736-20.797 20.611-11.082 53.708-10.363 73.877 1.511 10.268 6.045 15.218 13.889 14.849 21.517-.074 2.159-.591 4.246-1.552 6.261-2.29 5.109-7.018 9.858-14.184 13.744-20.685 11.155-53.708 10.435-73.877-1.439Z",
    fill: "url(#right_graphic_svg__t)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M143.808 461.674c-7.905-4.677-12.929-10.218-15.219-16.047-.886-2.303-1.403-4.678-1.403-6.981v-.216c0-8.563 5.91-17.055 17.656-23.315 23.124-12.378 60.21-11.658 82.816 1.727 11.525 6.764 17.065 15.544 16.622 24.107-.148 2.375-.665 4.75-1.699 7.052-2.512 5.685-7.831 11.083-15.883 15.4-23.272 12.378-60.358 11.658-82.89-1.727Z",
    fill: "url(#right_graphic_svg__u)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    d: "M139.301 450.376c-8.717-5.181-14.332-11.298-16.917-17.775-1.035-2.59-1.552-5.181-1.552-7.772v-.287c0-9.499 6.501-18.855 19.578-25.835 25.635-13.745 66.71-12.881 91.755 1.871 12.78 7.556 18.912 17.199 18.395 26.77a21.469 21.469 0 0 1-1.921 7.844c-2.807 6.333-8.717 12.234-17.657 17.055-25.635 13.745-66.71 12.881-91.681-1.871Z",
    fill: "url(#right_graphic_svg__v)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.214,
    d: "M134.721 439.006c-9.604-5.685-15.736-12.45-18.543-19.502-1.108-2.806-1.699-5.685-1.699-8.491v-.288c0-10.435 7.166-20.725 21.424-28.353 28.147-15.041 73.212-14.177 100.694 2.087 13.963 8.275 20.686 18.926 20.242 29.36a23.83 23.83 0 0 1-2.068 8.564c-3.103 6.908-9.53 13.457-19.356 18.71-28.147 15.04-73.212 14.104-100.694-2.087Z",
    fill: "url(#right_graphic_svg__w)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.127,
    d: "M130.215 427.708c-10.417-6.189-17.14-13.529-20.169-21.229-1.182-3.094-1.847-6.189-1.847-9.283v-.288c0-11.298 7.831-22.524 23.346-30.872 30.658-16.407 79.713-15.4 109.633 2.231 15.218 8.995 22.532 20.581 22.015 31.951-.148 3.167-.887 6.261-2.29 9.355-3.325 7.556-10.417 14.609-21.055 20.366-30.659 16.407-79.713 15.4-109.633-2.231Z",
    fill: "url(#right_graphic_svg__x)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M125.708 416.338c-11.303-6.693-18.543-14.609-21.793-22.956-1.33-3.31-1.995-6.693-1.995-10.003v-.36c0-12.233 8.422-24.395 25.266-33.39 33.17-17.775 86.214-16.624 118.572 2.446 16.474 9.715 24.379 22.237 23.788 34.542-.148 3.383-.96 6.765-2.438 10.075-3.62 8.204-11.229 15.832-22.828 22.021-33.17 17.774-86.288 16.695-118.572-2.375Z",
    fill: "#09BFFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M158.066 472.181c-5.984-2.951-9.973-6.693-11.894-10.723a13.978 13.978 0 0 1-1.404-4.965v-.144c-.517-6.189 3.325-12.593 11.451-17.775 16.031-10.218 42.849-11.658 59.914-3.238 8.718 4.318 13.224 10.291 13.372 16.551.074 1.727-.222 3.454-.813 5.182-1.477 4.245-5.023 8.419-10.638 11.945-16.031 10.147-42.922 11.586-59.988 3.167Z",
    fill: "#FFCB29"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.897 467.143c-4.359-2.159-7.24-4.893-8.718-7.844-.591-1.151-.886-2.374-1.034-3.598v-.144c-.369-4.533 2.364-9.211 8.348-13.025 11.673-7.484 31.25-8.491 43.735-2.375 6.354 3.095 9.604 7.556 9.752 12.09.074 1.295-.148 2.519-.591 3.814-1.108 3.094-3.694 6.117-7.757 8.708-11.673 7.484-31.25 8.563-43.735 2.374Z",
    fill: "#FFA800"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.783 467.575c-4.285-2.087-7.092-4.749-8.496-7.628-.591-1.151-.886-2.375-1.034-3.526v-.144c-.369-4.39 2.364-8.995 8.127-12.665 11.451-7.269 30.511-8.348 42.7-2.303 6.206 3.022 9.383 7.34 9.53 11.802.074 1.223-.147 2.446-.591 3.67-1.108 3.022-3.619 5.973-7.609 8.563-11.377 7.196-30.437 8.204-42.627 2.231Z",
    fill: "#FFAF04"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M158.731 483.191c-8.126-4.03-12.559-9.499-13.298-15.328l-.074-1.655-.591-9.715c.148 1.655.591 3.382 1.404 4.965 1.995 4.102 5.984 7.844 11.894 10.723 17.066 8.419 43.883 6.98 59.914-3.239 5.615-3.526 9.087-7.7 10.638-11.945.591-1.727.887-3.454.813-5.182l.443 9.14.148 3.166c-.369 5.541-4.137 11.226-11.451 15.832-15.957 10.146-42.774 11.586-59.84 3.238Z",
    fill: "#FAB406"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.823 437.639c15.883 1.511 25.783 10.146 22.163 19.286-3.694 9.211-19.652 15.471-35.609 13.888-15.957-1.583-25.857-10.29-22.015-19.43 3.767-9.139 19.577-15.256 35.461-13.744Z",
    fill: "#FFF1DE"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M192.641 449.153s1.625-1.943-2.808-3.958c-4.506-2.159-10.195.791-11.672 1.655l-5.467-2.735-3.029 1.943 5.467 2.735-2.143 1.367-5.466-2.735-3.029 1.943 5.466 2.735-5.688 3.67 3.103 1.511 2.216-1.439c1.33-.863 2.66-.288 2.66-.288s13.297 6.621 13.962 6.981c.665.359.148.719.148.719l-2.512 1.583 3.177 2.447 5.91-3.814 5.245 2.591 3.029-1.943-5.245-2.591 2.143-1.367 5.245 2.59 3.029-1.943-5.246-2.59c.148-.072.444-.288 1.109-.792 4.654-3.31 4.211-6.189-.222-8.347-4.359-2.159-9.382.072-9.382.072Zm-16.179 2.662 2.881-1.871s3.841-2.231 6.723-.863c2.881 1.439-.887 4.03-.887 4.03l-2.659 1.727-6.058-3.023Zm18.986 5.757-3.251 2.087-6.722-3.31 3.546-2.231s4.654-2.735 7.757-1.151c3.25 1.511-1.33 4.605-1.33 4.605Z",
    fill: "#FFC261"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M472.707 302.062c19.503 0 35.313-8.893 35.313-19.862 0-10.969-15.81-19.862-35.313-19.862s-35.313 8.893-35.313 19.862c0 10.969 15.81 19.862 35.313 19.862Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M497.677 260.755c3.768 2.087 8.644-12.881 10.343-10.29l-.074 25.69c-.591 4.606-3.989 9.139-10.269 12.666-13.815 7.772-36.126 7.772-49.94 0-6.871-3.886-10.343-8.996-10.343-14.033v-22.596c1.699-2.447 46.468.791 60.283 8.563Z",
    fill: "url(#right_graphic_svg__y)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M472.707 270.614c19.503 0 35.313-8.892 35.313-19.862 0-10.969-15.81-19.861-35.313-19.861s-35.313 8.892-35.313 19.861c0 10.97 15.81 19.862 35.313 19.862Z",
    fill: "url(#right_graphic_svg__z)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M472.707 269.823c19.503 0 35.313-8.893 35.313-19.862 0-10.969-15.81-19.862-35.313-19.862s-35.313 8.893-35.313 19.862c0 10.969 15.81 19.862 35.313 19.862Z",
    fill: "url(#right_graphic_svg__A)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M472.707 264.857c14.607 0 26.448-6.669 26.448-14.896s-11.841-14.896-26.448-14.896c-14.607 0-26.448 6.669-26.448 14.896s11.841 14.896 26.448 14.896Z",
    fill: "url(#right_graphic_svg__B)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M472.707 260.467c10.322 0 18.691-4.704 18.691-10.506 0-5.803-8.369-10.507-18.691-10.507-10.323 0-18.691 4.704-18.691 10.507 0 5.802 8.368 10.506 18.691 10.506Z",
    fill: "#09BFFF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M464.507 256.725c-1.552-.935-2.512-2.015-2.955-3.094-.148-.432-.296-.936-.296-1.367v-.072c0-1.655 1.182-3.311 3.398-4.534 4.507-2.447 11.747-2.231 16.106.36 2.216 1.295 3.324 3.022 3.25 4.677 0 .432-.148.936-.369 1.368-.517 1.079-1.552 2.159-3.103 3.022-4.433 2.375-11.599 2.231-16.031-.36Z",
    fill: "url(#right_graphic_svg__C)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913,
    d: "M460.886 247.658c-2.216-1.295-3.62-2.878-4.284-4.533-.222-.648-.37-1.296-.37-1.943v-.072c0-2.375 1.625-4.75 4.95-6.549 6.501-3.454 16.918-3.238 23.271.504 3.251 1.871 4.802 4.39 4.654 6.764 0 .648-.221 1.368-.517 2.015-.739 1.583-2.216 3.095-4.432 4.318-6.502 3.454-16.918 3.238-23.272-.504Z",
    fill: "url(#right_graphic_svg__D)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M457.267 238.591c-2.881-1.727-4.728-3.742-5.615-5.901a6.495 6.495 0 0 1-.517-2.591v-.072c0-3.166 2.142-6.26 6.501-8.563 8.496-4.534 22.089-4.246 30.363.648 4.211 2.518 6.28 5.685 6.132 8.851-.074.863-.221 1.727-.665 2.591-.96 2.086-2.881 4.029-5.836 5.613-8.422 4.605-22.015 4.317-30.363-.576Z",
    fill: "url(#right_graphic_svg__E)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.738,
    d: "M453.721 229.524c-3.546-2.087-5.91-4.606-6.945-7.269-.443-1.079-.591-2.086-.665-3.166v-.072c0-3.886 2.66-7.7 7.979-10.578 10.491-5.613 27.334-5.254 37.529.791 5.246 3.095 7.757 7.053 7.536 10.939-.074 1.079-.296 2.158-.813 3.166-1.182 2.591-3.546 5.037-7.24 6.98-10.342 5.613-27.186 5.254-37.381-.791Z",
    fill: "url(#right_graphic_svg__F)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M450.101 220.457c-4.285-2.519-7.019-5.542-8.201-8.636a9.651 9.651 0 0 1-.738-3.742v-.144c0-4.605 3.176-9.211 9.53-12.593 12.485-6.693 32.505-6.261 44.695.935 6.206 3.67 9.161 8.42 8.939 13.025-.074 1.296-.369 2.591-.96 3.814-1.404 3.095-4.211 5.973-8.57 8.276-12.559 6.693-32.506 6.261-44.695-.935Z",
    fill: "url(#right_graphic_svg__G)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.564,
    d: "M446.481 211.389c-4.95-2.878-8.127-6.404-9.53-10.002a11.65 11.65 0 0 1-.887-4.39v-.144c0-5.325 3.694-10.651 11.082-14.608 14.48-7.772 37.677-7.269 51.861 1.079 7.166 4.246 10.638 9.715 10.417 15.112-.074 1.511-.443 2.951-1.108 4.39-1.626 3.598-4.876 6.908-9.974 9.643-14.553 7.772-37.751 7.268-51.861-1.08Z",
    fill: "url(#right_graphic_svg__H)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.476,
    d: "M442.861 202.322c-5.615-3.31-9.235-7.268-10.86-11.442-.665-1.655-.961-3.31-1.034-4.965v-.144c0-6.117 4.211-12.162 12.559-16.624 16.474-8.851 42.922-8.275 58.953 1.224 8.201 4.821 12.116 11.082 11.821 17.199-.074 1.727-.518 3.382-1.256 5.037-1.773 4.102-5.615 7.844-11.303 10.938-16.401 8.852-42.849 8.276-58.88-1.223Z",
    fill: "url(#right_graphic_svg__I)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M439.241 193.327c-6.28-3.742-10.343-8.132-12.19-12.81-.739-1.871-1.108-3.742-1.108-5.613v-.216c0-6.836 4.728-13.601 14.111-18.638 18.469-9.931 48.093-9.283 66.119 1.367 9.161 5.398 13.594 12.378 13.298 19.286a13.99 13.99 0 0 1-1.404 5.613c-1.994 4.534-6.279 8.852-12.706 12.306-18.47 9.931-48.094 9.283-66.12-1.295Z",
    fill: "url(#right_graphic_svg__J)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    d: "M435.621 184.259c-6.945-4.101-11.451-9.067-13.52-14.176-.812-2.015-1.256-4.102-1.256-6.189v-.216c0-7.556 5.246-15.04 15.588-20.653 20.464-10.938 53.266-10.291 73.286 1.511 10.195 5.973 15.071 13.745 14.702 21.373-.074 2.087-.591 4.174-1.552 6.261-2.216 5.037-6.944 9.787-14.11 13.601-20.39 10.938-53.191 10.29-73.138-1.512Z",
    fill: "url(#right_graphic_svg__K)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.214,
    d: "M432.001 175.192c-7.683-4.533-12.559-9.931-14.775-15.544-.887-2.231-1.33-4.533-1.33-6.764v-.216c0-8.276 5.762-16.551 17.139-22.668 22.459-12.018 58.437-11.298 80.378 1.655 11.156 6.621 16.549 15.112 16.105 23.46-.073 2.302-.664 4.605-1.699 6.836-2.438 5.541-7.609 10.722-15.44 14.968-22.459 11.946-58.436 11.226-80.378-1.727Z",
    fill: "url(#right_graphic_svg__L)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.127,
    d: "M428.381 166.125c-8.348-4.894-13.741-10.795-16.105-16.911-.961-2.447-1.478-4.894-1.478-7.412v-.216c0-9.068 6.206-17.991 18.691-24.683 24.453-13.098 63.682-12.306 87.544 1.799 12.19 7.196 18.026 16.407 17.583 25.546a21.033 21.033 0 0 1-1.847 7.484c-2.66 6.045-8.274 11.658-16.844 16.264-24.453 13.025-63.682 12.233-87.544-1.871Z",
    fill: "url(#right_graphic_svg__M)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M424.761 157.058c-9.013-5.326-14.849-11.658-17.435-18.351a23.71 23.71 0 0 1-1.625-7.988v-.287c0-9.787 6.723-19.502 20.168-26.698 26.448-14.177 68.853-13.313 94.71 1.943 13.15 7.772 19.504 17.774 18.987 27.633-.148 2.735-.813 5.397-1.995 8.06-2.881 6.548-8.939 12.665-18.174 17.559-26.448 14.248-68.779 13.385-94.636-1.871Z",
    fill: "#09BFFF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M450.323 180.158c-2.808-4.102-3.99-7.988-3.768-11.37.074-1.368.443-2.591.96-3.814l.074-.144c2.069-4.246 7.019-7.125 14.332-7.556 14.406-.936 32.654 7.844 40.706 19.573 4.064 5.973 4.728 11.586 2.512 15.76-.591 1.152-1.477 2.231-2.512 3.095-2.585 2.23-6.501 3.742-11.598 4.029-14.48.864-32.654-7.915-40.706-19.573Z",
    fill: "#FFCB29"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M457.414 179.654c-2.068-2.951-2.881-5.829-2.733-8.348.074-1.007.295-1.943.739-2.734l.074-.072c1.477-3.095 5.097-5.182 10.416-5.541 10.565-.648 23.789 5.757 29.699 14.32 2.955 4.39 3.472 8.42 1.847 11.514-.444.864-1.109 1.583-1.847 2.303-1.921 1.655-4.728 2.735-8.422 2.95-10.639.576-23.936-5.829-29.773-14.392Z",
    fill: "#FFA800"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M457.784 180.23c-1.995-2.951-2.881-5.685-2.659-8.132a8.725 8.725 0 0 1 .664-2.735l.074-.072c1.478-3.022 4.95-5.109 10.195-5.397 10.269-.647 23.272 5.613 29.034 13.961 2.881 4.246 3.398 8.276 1.773 11.226-.443.792-1.034 1.583-1.773 2.231-1.847 1.583-4.654 2.662-8.274 2.878-10.343.648-23.271-5.613-29.034-13.96Z",
    fill: "#FFAF04"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M446.555 187.57c-3.842-5.613-4.655-10.795-2.881-14.896l.591-1.08 3.324-6.62c-.517 1.151-.887 2.446-.96 3.814-.222 3.382.96 7.34 3.767 11.37 8.053 11.73 26.227 20.509 40.706 19.573 5.024-.287 8.94-1.799 11.599-4.029 1.034-.936 1.921-1.943 2.512-3.095l-3.177 6.189-1.108 2.159c-2.364 3.526-7.018 5.829-13.593 6.261-14.554.863-32.802-7.916-40.78-19.646Z",
    fill: "#FAB406"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M487.039 170.371c9.826 6.764 13.076 16.047 7.24 20.725-5.91 4.749-18.839 3.022-28.738-3.742-9.9-6.837-13.076-16.12-7.092-20.797 5.91-4.678 18.764-2.951 28.59 3.814Z",
    fill: "#FFF1DE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M481.868 177.495s1.773-.72-.296-3.598c-2.142-3.094-6.944-3.166-8.348-3.166l-2.586-3.742-2.733.143 2.586 3.742-1.921.144-2.586-3.742-2.733.144 2.585 3.742-5.097.36 1.478 2.159s.812-.072 1.994-.144 1.847.792 1.847.792 6.206 9.139 6.575 9.643c.296.503-.221.503-.221.503l-2.291.144 1.182 2.807 5.32-.36 2.437 3.598 2.734-.216-2.438-3.598 1.921-.144 2.438 3.598 2.733-.216-2.438-3.598c.148 0 .443-.072 1.034-.072 4.359-.503 5.098-2.518 3.029-5.541-2.068-3.022-6.205-3.382-6.205-3.382Zm-11.673-4.102 2.66-.144s3.398-.072 4.728 1.871c1.33 1.943-2.143 2.303-2.143 2.303l-2.437.144-2.808-4.174Zm10.343 10.723-2.881.215-3.177-4.605 3.177-.216s4.063-.144 5.541 2.015c1.477 2.159-2.66 2.591-2.66 2.591Z",
    fill: "#FFC261"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M70.448 384.531c20.36 0 36.865-9.279 36.865-20.726 0-11.446-16.505-20.725-36.865-20.725-20.36 0-36.864 9.279-36.864 20.725 0 11.447 16.505 20.726 36.864 20.726Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M96.527 341.353c3.915 2.231 9.013-13.457 10.786-10.722l-.074 26.842c-.591 4.821-4.137 9.571-10.712 13.241-14.406 8.132-37.751 8.132-52.157 0-7.166-4.03-10.786-9.355-10.786-14.68V332.43c1.847-2.591 48.537.864 62.943 8.923Z",
    fill: "url(#right_graphic_svg__N)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M70.448 351.644c20.36 0 36.865-9.279 36.865-20.725 0-11.446-16.505-20.725-36.865-20.725-20.36 0-36.864 9.279-36.864 20.725 0 11.446 16.505 20.725 36.864 20.725Z",
    fill: "url(#right_graphic_svg__O)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M70.448 350.852c20.36 0 36.865-9.279 36.865-20.725 0-11.446-16.505-20.725-36.865-20.725-20.36 0-36.864 9.279-36.864 20.725 0 11.446 16.505 20.725 36.864 20.725Z",
    fill: "url(#right_graphic_svg__P)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M70.448 345.671c15.26 0 27.63-6.959 27.63-15.544 0-8.584-12.37-15.544-27.63-15.544s-27.63 6.96-27.63 15.544c0 8.585 12.37 15.544 27.63 15.544Z",
    fill: "url(#right_graphic_svg__Q)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M70.448 341.137c10.772 0 19.504-4.929 19.504-11.01 0-6.081-8.732-11.01-19.504-11.01-10.77 0-19.503 4.929-19.503 11.01 0 6.081 8.732 11.01 19.503 11.01Z",
    fill: "#09BFFF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M61.953 337.18c-1.626-.936-2.66-2.087-3.103-3.239-.148-.503-.296-.935-.296-1.439v-.072c0-1.727 1.182-3.454 3.62-4.749 4.729-2.519 12.264-2.375 16.844.359 2.364 1.368 3.472 3.167 3.399 4.894 0 .504-.148.935-.37 1.439-.517 1.151-1.625 2.231-3.25 3.094-4.728 2.519-12.264 2.375-16.844-.287Z",
    fill: "url(#right_graphic_svg__R)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913,
    d: "M58.185 327.681c-2.29-1.368-3.768-3.023-4.433-4.678-.295-.648-.369-1.367-.443-2.015v-.072c0-2.519 1.7-4.965 5.172-6.836 6.796-3.598 17.656-3.383 24.305.503 3.398 2.015 5.023 4.534 4.876 7.053 0 .719-.222 1.367-.517 2.087-.74 1.655-2.29 3.238-4.655 4.533-6.796 3.598-17.656 3.311-24.305-.575Z",
    fill: "url(#right_graphic_svg__S)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M54.417 318.253c-3.029-1.799-4.95-3.886-5.836-6.116-.37-.864-.517-1.799-.517-2.663v-.072c0-3.31 2.29-6.549 6.796-8.923 8.866-4.75 23.05-4.462 31.767.647 4.433 2.591 6.502 5.973 6.354 9.284-.074.935-.296 1.799-.665 2.734-.96 2.159-3.03 4.246-6.132 5.901-8.939 4.606-23.123 4.318-31.767-.792Z",
    fill: "url(#right_graphic_svg__T)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.738,
    d: "M50.65 308.754c-3.694-2.23-6.132-4.821-7.24-7.556a8.818 8.818 0 0 1-.665-3.31v-.144c0-4.03 2.807-8.06 8.348-11.01 10.933-5.901 28.516-5.469 39.228.792 5.467 3.238 8.053 7.34 7.831 11.442-.074 1.151-.295 2.23-.813 3.31-1.181 2.734-3.693 5.253-7.535 7.268-10.934 5.901-28.516 5.541-39.155-.792Z",
    fill: "url(#right_graphic_svg__U)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M46.882 299.327c-4.433-2.59-7.314-5.757-8.57-8.995-.517-1.295-.813-2.591-.813-3.958v-.144c0-4.821 3.325-9.571 9.974-13.169 13.002-6.98 33.91-6.549 46.69.936 6.501 3.814 9.604 8.779 9.382 13.6a10.737 10.737 0 0 1-.96 3.958c-1.404 3.239-4.433 6.261-8.94 8.636-13.15 7.052-34.056 6.62-46.763-.864Z",
    fill: "url(#right_graphic_svg__V)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.564,
    d: "M43.114 289.828c-5.171-3.022-8.496-6.692-9.973-10.434a12.458 12.458 0 0 1-.887-4.606v-.144c0-5.613 3.842-11.154 11.525-15.256 15.145-8.131 39.376-7.628 54.152 1.08 7.535 4.461 11.155 10.146 10.859 15.759-.073 1.584-.443 3.095-1.108 4.606-1.625 3.742-5.097 7.196-10.416 10.075-15.219 8.132-39.45 7.628-54.152-1.08Z",
    fill: "url(#right_graphic_svg__W)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.476,
    d: "M39.346 280.401c-5.836-3.454-9.604-7.628-11.303-11.945-.665-1.727-1.034-3.455-1.034-5.182v-.144c0-6.332 4.358-12.665 13.15-17.343 17.213-9.211 44.77-8.635 61.539 1.296 8.57 5.037 12.707 11.586 12.338 17.918-.074 1.799-.518 3.527-1.256 5.254-1.921 4.245-5.837 8.203-11.821 11.442-17.287 9.211-44.843 8.635-61.613-1.296Z",
    fill: "url(#right_graphic_svg__X)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M35.505 270.974c-6.575-3.886-10.786-8.491-12.707-13.385-.739-1.943-1.182-3.886-1.182-5.829v-.216c0-7.124 4.95-14.176 14.701-19.43 19.282-10.362 50.237-9.714 69.001 1.44 9.604 5.685 14.185 12.953 13.889 20.149-.074 2.015-.591 3.958-1.404 5.901-2.142 4.75-6.501 9.211-13.297 12.809-19.208 10.291-50.163 9.643-69.001-1.439Z",
    fill: "url(#right_graphic_svg__Y)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    d: "M31.737 261.475c-7.314-4.317-11.968-9.427-14.11-14.824-.813-2.159-1.256-4.318-1.33-6.477v-.215c0-7.916 5.467-15.76 16.327-21.517 21.35-11.442 55.629-10.723 76.462 1.583 10.638 6.261 15.736 14.392 15.366 22.308-.073 2.231-.664 4.39-1.551 6.549-2.364 5.253-7.24 10.219-14.701 14.176-21.35 11.442-55.556 10.723-76.463-1.583Z",
    fill: "url(#right_graphic_svg__Z)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.214,
    d: "M27.97 252.048c-7.98-4.749-13.15-10.363-15.44-16.263-.887-2.375-1.404-4.75-1.404-7.125v-.216c0-8.707 5.984-17.271 17.878-23.675 23.492-12.594 61.022-11.802 83.924 1.727 11.672 6.908 17.287 15.76 16.844 24.467-.148 2.447-.665 4.822-1.774 7.124-2.585 5.757-7.978 11.226-16.105 15.616-23.419 12.594-61.022 11.802-83.924-1.655Z",
    fill: "url(#right_graphic_svg__aa)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.127,
    d: "M24.201 242.549c-8.717-5.109-14.332-11.298-16.843-17.703-1.035-2.518-1.552-5.109-1.552-7.7v-.288c0-9.427 6.501-18.782 19.504-25.762 25.561-13.673 66.489-12.809 91.385 1.871 12.707 7.484 18.839 17.127 18.322 26.626-.148 2.663-.739 5.253-1.921 7.772-2.808 6.333-8.644 12.233-17.583 16.983-25.413 13.817-66.341 12.953-91.312-1.799Z",
    fill: "url(#right_graphic_svg__ab)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M20.434 233.122C11.05 227.581 4.92 220.888 2.26 213.98c-1.108-2.735-1.625-5.541-1.699-8.348v-.287c0-10.219 7.018-20.366 21.055-27.85 27.63-14.824 71.882-13.889 98.847 2.015 13.741 8.132 20.316 18.566 19.873 28.785a22.774 22.774 0 0 1-2.069 8.42c-3.029 6.836-9.382 13.169-18.986 18.35-27.63 14.896-71.882 13.961-98.847-1.943Z",
    fill: "#09BFFF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M478.026 481.32c24.44 0 44.252-11.148 44.252-24.899 0-13.751-19.812-24.899-44.252-24.899-24.439 0-44.252 11.148-44.252 24.899 0 13.751 19.813 24.899 44.252 24.899Z",
    fill: "#000",
    fillOpacity: 0.2
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M509.276 429.507c4.728 2.663 10.786-16.192 12.929-12.881l-.074 32.167c-.739 5.757-5.024 11.442-12.855 15.904-17.287 9.714-45.286 9.714-62.499 0-8.644-4.822-12.929-11.227-12.929-17.559v-28.281c2.143-3.167 58.141.935 75.428 10.65Z",
    fill: "url(#right_graphic_svg__ac)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M478.026 441.885c24.44 0 44.252-11.148 44.252-24.899 0-13.752-19.812-24.899-44.252-24.899-24.439 0-44.252 11.147-44.252 24.899 0 13.751 19.813 24.899 44.252 24.899Z",
    fill: "url(#right_graphic_svg__ad)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M478.026 440.949c24.44 0 44.252-11.148 44.252-24.899 0-13.751-19.812-24.899-44.252-24.899-24.439 0-44.252 11.148-44.252 24.899 0 13.751 19.813 24.899 44.252 24.899Z",
    fill: "url(#right_graphic_svg__ae)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M478.026 434.688c18.32 0 33.171-8.344 33.171-18.638 0-10.293-14.851-18.638-33.171-18.638-18.319 0-33.17 8.345-33.17 18.638 0 10.294 14.851 18.638 33.17 18.638Z",
    fill: "url(#right_graphic_svg__af)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M478.026 429.219c12.934 0 23.419-5.896 23.419-13.169 0-7.273-10.485-13.169-23.419-13.169-12.934 0-23.419 5.896-23.419 13.169 0 7.273 10.485 13.169 23.419 13.169Z",
    fill: "#09BFFF"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M467.832 424.47c-1.921-1.152-3.177-2.519-3.694-3.886-.222-.576-.37-1.152-.37-1.727v-.072c0-2.087 1.404-4.174 4.285-5.685 5.615-3.023 14.702-2.807 20.168.431 2.808 1.656 4.138 3.814 4.064 5.901 0 .576-.148 1.152-.444 1.727-.591 1.368-1.92 2.663-3.841 3.742-5.689 3.023-14.702 2.807-20.168-.431Z",
    fill: "url(#right_graphic_svg__ag)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.913,
    d: "M463.251 413.1c-2.807-1.656-4.58-3.599-5.393-5.614-.295-.791-.517-1.655-.517-2.446v-.072c0-3.023 2.069-5.973 6.206-8.204 8.126-4.39 21.202-4.102 29.107.576 4.063 2.375 5.984 5.469 5.836 8.491-.073.864-.221 1.656-.591 2.447-.886 2.015-2.733 3.886-5.614 5.397-8.053 4.39-21.055 4.174-29.034-.575Z",
    fill: "url(#right_graphic_svg__ah)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.826,
    d: "M458.745 401.801c-3.62-2.158-5.984-4.677-7.019-7.34-.443-1.079-.664-2.159-.664-3.238v-.072c0-3.958 2.733-7.844 8.126-10.722 10.638-5.685 27.704-5.326 38.046.791 5.32 3.095 7.831 7.124 7.61 11.082-.074 1.08-.296 2.159-.813 3.239-1.182 2.59-3.62 5.109-7.314 7.052-10.564 5.685-27.556 5.325-37.972-.792Z",
    fill: "url(#right_graphic_svg__ai)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.738,
    d: "M454.238 390.431c-4.506-2.662-7.387-5.829-8.643-9.067-.517-1.295-.813-2.663-.813-3.958v-.144c0-4.893 3.324-9.643 10.047-13.241 13.15-7.052 34.205-6.62 46.986.936 6.501 3.886 9.678 8.851 9.456 13.673a11.459 11.459 0 0 1-.96 4.029c-1.478 3.239-4.433 6.261-9.013 8.708-13.224 7.052-34.279 6.62-47.06-.936Z",
    fill: "url(#right_graphic_svg__aj)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.651,
    d: "M449.732 379.133c-5.319-3.166-8.792-6.908-10.269-10.794-.591-1.583-.961-3.166-.961-4.749v-.144c0-5.757 3.99-11.514 11.895-15.76 15.661-8.348 40.706-7.844 55.924 1.151 7.757 4.606 11.525 10.507 11.23 16.336-.074 1.583-.444 3.238-1.182 4.749-1.7 3.886-5.32 7.484-10.786 10.363-15.588 8.347-40.633 7.844-55.851-1.152Z",
    fill: "url(#right_graphic_svg__ak)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.564,
    d: "M445.151 367.763c-6.205-3.67-10.195-7.987-11.968-12.521-.738-1.799-1.108-3.67-1.108-5.469v-.216c0-6.693 4.654-13.385 13.815-18.279 18.174-9.714 47.207-9.139 64.938 1.368 9.013 5.325 13.371 12.161 13.002 18.926a14.854 14.854 0 0 1-1.33 5.541c-1.994 4.462-6.131 8.635-12.485 12.09-18.1 9.643-47.133 8.995-64.864-1.44Z",
    fill: "url(#right_graphic_svg__al)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.476,
    d: "M440.645 356.393c-7.018-4.174-11.599-9.139-13.593-14.32-.813-2.087-1.256-4.174-1.256-6.261v-.216c0-7.628 5.245-15.184 15.735-20.797 20.612-11.082 53.709-10.363 73.877 1.511 10.269 6.045 15.219 13.889 14.849 21.517-.074 2.159-.591 4.246-1.551 6.261-2.29 5.109-7.018 9.858-14.184 13.744-20.686 11.155-53.709 10.435-73.877-1.439Z",
    fill: "url(#right_graphic_svg__am)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M436.138 345.095c-7.904-4.677-12.928-10.219-15.218-16.047-.887-2.303-1.404-4.678-1.404-6.981v-.216c0-8.563 5.91-17.055 17.657-23.316 23.123-12.377 60.209-11.657 82.815 1.728 11.525 6.764 17.066 15.543 16.623 24.107-.148 2.375-.665 4.749-1.699 7.052-2.512 5.685-7.831 11.082-15.884 15.4-23.271 12.378-60.357 11.586-82.89-1.727Z",
    fill: "url(#right_graphic_svg__an)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    d: "M431.632 333.725c-8.718-5.181-14.332-11.298-16.918-17.775-1.034-2.59-1.551-5.181-1.551-7.771v-.288c0-9.499 6.501-18.854 19.577-25.835 25.635-13.745 66.711-12.881 91.755 1.871 12.781 7.556 18.912 17.199 18.395 26.77a21.464 21.464 0 0 1-1.921 7.844c-2.807 6.333-8.717 12.234-17.656 17.055-25.635 13.745-66.711 12.881-91.681-1.871Z",
    fill: "url(#right_graphic_svg__ao)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.214,
    d: "M427.051 322.355c-9.604-5.685-15.735-12.449-18.543-19.502-1.108-2.806-1.699-5.685-1.699-8.491v-.288c0-10.435 7.166-20.725 21.424-28.353 28.147-15.04 73.212-14.177 100.694 2.087 13.963 8.275 20.686 18.926 20.243 29.36a23.852 23.852 0 0 1-2.069 8.564c-3.103 6.908-9.53 13.457-19.356 18.71-28.147 15.112-73.212 14.177-100.694-2.087Z",
    fill: "url(#right_graphic_svg__ap)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.127,
    d: "M422.545 311.057c-10.417-6.189-17.139-13.529-20.168-21.229-1.182-3.094-1.847-6.189-1.847-9.283v-.288c0-11.298 7.831-22.524 23.345-30.872 30.659-16.407 79.713-15.4 109.633 2.231 15.219 8.995 22.532 20.581 22.015 31.951-.148 3.167-.886 6.261-2.29 9.355-3.324 7.557-10.417 14.609-21.055 20.366-30.659 16.407-79.713 15.4-109.633-2.231Z",
    fill: "url(#right_graphic_svg__aq)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.04,
    d: "M418.039 299.687c-11.304-6.693-18.544-14.608-21.794-22.956-1.33-3.31-1.995-6.693-1.995-10.003v-.36c0-12.233 8.422-24.395 25.266-33.39 33.171-17.775 86.214-16.623 118.572 2.447 16.475 9.715 24.38 22.236 23.789 34.542-.148 3.382-.961 6.764-2.438 10.074-3.62 8.204-11.23 15.832-22.828 22.021-33.171 17.846-86.288 16.695-118.572-2.375Z",
    fill: "#09BFFF"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M451.209 347.758c-6.132-2.159-10.416-5.397-12.78-9.068-.961-1.511-1.626-3.022-1.921-4.677v-.144c-1.182-5.901 1.773-12.593 9.013-18.494 14.332-11.586 40.115-15.904 57.624-9.643 8.939 3.166 13.962 8.563 14.849 14.536a14.95 14.95 0 0 1-.222 5.109c-.96 4.318-3.915 8.708-8.939 12.738-14.332 11.658-40.115 15.975-57.624 9.643Z",
    fill: "#FFCB29"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M458.227 342.073c-4.432-1.583-7.609-3.958-9.308-6.621-.665-1.079-1.182-2.231-1.404-3.382v-.144c-.886-4.318 1.256-9.139 6.575-13.457 10.417-8.491 29.255-11.658 42.036-7.052 6.501 2.303 10.195 6.26 10.86 10.578.148 1.224.148 2.447-.148 3.742-.739 3.095-2.881 6.333-6.501 9.283-10.564 8.492-29.329 11.658-42.11 7.053Z",
    fill: "#FFA800"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M459.114 342.433c-4.359-1.584-7.388-3.814-9.087-6.477a11.794 11.794 0 0 1-1.404-3.31v-.144c-.812-4.246 1.256-8.996 6.428-13.169 10.195-8.276 28.59-11.37 41.075-6.909 6.354 2.303 9.974 6.117 10.565 10.363.147 1.151.147 2.375-.148 3.67-.665 3.022-2.808 6.189-6.354 9.067-10.268 8.276-28.664 11.37-41.075 6.909Z",
    fill: "#FFAF04"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M453.056 358.336c-8.348-3.022-13.298-7.844-14.627-13.385l-.296-1.583-1.699-9.355c.369 1.583.96 3.166 1.921 4.677 2.364 3.742 6.649 6.909 12.78 9.068 17.509 6.26 43.292 1.943 57.624-9.643 5.024-4.03 7.905-8.42 8.939-12.738.37-1.727.444-3.454.222-5.109l1.477 8.779.518 3.023c.295 5.397-2.734 11.298-9.235 16.551-14.332 11.658-40.115 15.976-57.624 9.715Z",
    fill: "#FAB406"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M481.794 310.553c15.514-.216 26.152 6.981 23.641 16.264-2.512 9.283-17.214 17.055-32.876 17.271-15.661.216-26.152-7.125-23.566-16.408 2.659-9.283 17.361-16.911 32.801-17.127Z",
    fill: "#FFF1DE"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M482.016 321.779s1.33-2.015-3.177-3.526c-4.654-1.583-9.752 1.871-11.155 2.879l-5.615-2.015-2.66 2.159 5.615 2.015-1.921 1.583-5.614-2.015-2.66 2.159 5.615 2.015-5.098 4.101 3.177 1.152s.813-.648 1.995-1.583c1.182-.936 2.585-.576 2.585-.576s13.594 4.965 14.332 5.181c.665.288.222.72.222.72l-2.216 1.799 3.398 2.015 5.245-4.318 5.319 1.943 2.66-2.231-5.319-1.943 1.921-1.583 5.319 1.943 2.659-2.159-5.319-1.943c.148-.144.443-.36 1.034-.863 4.138-3.742 3.325-6.405-1.182-8.06-4.58-1.583-9.16 1.151-9.16 1.151Zm-15.367 4.318 2.586-2.087s3.472-2.59 6.427-1.583c2.955 1.079-.369 3.958-.369 3.958l-2.364 1.943-6.28-2.231Zm19.061 3.526-2.882 2.375-6.87-2.519 3.177-2.59s4.137-3.167 7.387-2.015c3.177 1.223-.812 4.749-.812 4.749Z",
    fill: "#FFC261"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "m88.992 220.529 42.774 24.035v-48.071l-42.774-24.107v48.143Z",
    fill: "#09BFFF"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m122.901 213.98-14.553-8.204c-.37-.216-.665-.719-.665-1.223 0-.432.295-.648.665-.504l14.553 8.204c.37.216.665.72.665 1.223 0 .504-.295.72-.665.504ZM122.901 217.434l-14.553-8.204c-.37-.215-.665-.719-.665-1.223 0-.432.295-.648.665-.504l14.553 8.204c.37.216.665.72.665 1.223 0 .432-.295.648-.665.504ZM122.901 220.817l-14.553-8.204c-.37-.216-.665-.72-.665-1.224 0-.431.295-.647.665-.503l14.553 8.203c.37.216.665.72.665 1.224 0 .432-.295.647-.665.504ZM122.901 224.199l-14.553-8.204c-.37-.216-.665-.719-.665-1.223 0-.432.295-.648.665-.504l14.553 8.204c.37.216.665.719.665 1.223 0 .432-.295.648-.665.504ZM122.901 231.971l-14.553-8.204c-.37-.216-.665-.72-.665-1.224 0-.431.295-.647.665-.503l14.553 8.203c.37.216.665.72.665 1.224s-.295.719-.665.504ZM122.901 235.425l-14.553-8.204c-.37-.216-.665-.719-.665-1.223 0-.432.295-.648.665-.504l14.553 8.204c.37.216.665.719.665 1.223 0 .432-.295.648-.665.504Z",
    fill: "#FFCB29"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M98.374 186.634c2.29 1.296 4.137 4.39 4.137 6.909v.072l1.404.791v-.072c0-3.454-2.438-7.556-5.467-9.283h-.074v1.583c-.074 0-.074 0 0 0Z",
    fill: "#FCAB49"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M102.437 193.686c-.074 2.447-1.847 3.455-4.137 2.231-2.29-1.295-4.137-4.389-4.137-6.908s1.847-3.598 4.063-2.303v-1.583c-3.029-1.655-5.466-.288-5.466 3.094 0 3.455 2.437 7.556 5.466 9.283 3.029 1.728 5.467.36 5.467-3.022l-1.256-.792Z",
    fill: "url(#right_graphic_svg__ar)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M97.71 202.034c1.477.864 2.733 2.951 2.733 4.606v.072l.96.504v-.072c0-2.303-1.625-5.038-3.694-6.189v1.079c0-.072 0 0 0 0Z",
    fill: "#FCAB49"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M100.443 206.712c0 1.655-1.256 2.303-2.734 1.511-1.477-.863-2.733-2.95-2.733-4.605 0-1.728 1.182-2.375 2.733-1.584v-1.079c-1.994-1.152-3.62-.216-3.62 2.087 0 2.303 1.626 5.037 3.694 6.189 1.995 1.151 3.62.215 3.694-2.015l-1.034-.504Z",
    fill: "url(#right_graphic_svg__as)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M67.863 343.584c21.502 0 38.933-9.794 38.933-21.876s-17.43-21.877-38.933-21.877c-21.502 0-38.933 9.795-38.933 21.877 0 12.082 17.43 21.876 38.933 21.876Z",
    fill: "url(#right_graphic_svg__at)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M67.863 338.187c16.198 0 29.33-7.378 29.33-16.479 0-9.102-13.132-16.48-29.33-16.48s-29.33 7.378-29.33 16.48c0 9.101 13.132 16.479 29.33 16.479Z",
    fill: "url(#right_graphic_svg__au)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M67.863 333.653c11.71 0 21.203-5.348 21.203-11.946 0-6.597-9.493-11.945-21.203-11.945-11.71 0-21.203 5.348-21.203 11.945 0 6.598 9.493 11.946 21.203 11.946Z",
    fill: "url(#right_graphic_svg__av)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M96.823 219.593c-1.182 1.151-.37 2.303 0 3.454.074-.432.074-.863.074-1.295 0-.504.221-1.008.738-1.223.296-.072.591 0 .887-.072.37-.072.59-.36.739-.648-.591-.648-1.33-.792-2.438-.216Z",
    fill: "#DD8AA6"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M100.295 217.722c0-.216-.074-.432-.148-.576-.37-.647-.886-1.151-1.551-1.439-.296-.144-.739-.288-.813-.648-.222-.575.517-1.007 1.108-1.151.591-.144 1.256-.432 1.256-1.007-.96-.432-2.142 0-2.881.719-.739.72-1.182 1.727-1.625 2.591-.517 1.007-.74 2.878-1.109 3.958-.369 1.007-1.108 2.015-.59 3.022.517 1.152 2.437 1.295 2.88 0 0-.072 0-.144.075-.144-.37-1.151-1.183-2.303 0-3.454 1.108-.504 1.846-.36 2.511.216.222-.36.37-.864.665-1.295 0-.216.222-.504.222-.792Z",
    fill: "#F2B1C7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M69.931 322.355c-.295.72-1.181 4.894 1.035 5.613 2.142.792 3.768-.072 5.467-1.655.221-.216-.591-.432-.296-.576 3.103-1.223 5.984-4.893 5.984-5.685 0-.935.222-1.655-1.773-1.655-1.995 0-5.762 2.951-5.762 2.951l-3.325-.936c-.074-.072-1.034 1.224-1.33 1.943ZM57.446 316.382s-.369 1.727 0 3.383c.148.791-.073 1.583.591 2.015.591.431 1.773.575 3.103.575 1.552 0 1.995-1.007 2.66-1.943.148-.216-.517-.575-.296-.719.74-.504 1.995-1.296 2.364-1.727 1.256-1.512 2.364-3.527 2.217-4.75-.148-1.223-1.478-1.511-2.143-1.511-.738 0-5.836 3.958-5.836 3.958l-2.66.719Z",
    fill: "#051A78"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M57.668 317.03c1.625 2.231 5.245 1.799 5.762-.936 1.847-9.786 3.103-26.841 3.177-40.874.074-9.931 1.404-20.509 1.182-23.028-3.842-2.159-10.343-3.67-11.155-2.087-5.024 9.859 1.108 12.665.738 17.055-.295 4.462.296 49.87.296 49.87Z",
    fill: "url(#right_graphic_svg__aw)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M77.098 251.041c2.29 1.223 2.29 17.199.96 28.209-1.256 11.082-1.33 41.954-2.438 42.889-1.108.936-4.728 2.159-5.319.72-.591-1.439-1.92-48.647-3.62-51.165-6.797-11.514-5.171-15.112-3.915-18.71 1.256-3.599 12.042-3.167 14.332-1.943Z",
    fill: "url(#right_graphic_svg__ax)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M74.216 194.478s1.33 10.219-.369 11.298c-1.625 1.08-7.535 1.152-9.16-1.151-1.626-2.303-5.172-9.715-1.257-12.378 3.842-2.662 9.013-3.022 10.786 2.231Z",
    fill: "#F4A2BA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M58.037 249.385c-1.108-.431-11.377-9.427-11.968-10.65-.517-1.223-.517-21.661 8.865-26.986 1.847-1.079 1.847 3.167 1.035 8.06-.739 4.749-5.837 15.328-5.024 16.767.813 1.439 8.127 8.995 9.235 10.579.665 1.079-1.035 2.662-2.143 2.23Z",
    fill: "url(#right_graphic_svg__ay)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M75.768 232.834c2.216-10.218 5.762-18.062.443-19.861-.37-.144-.739-.216-1.108-.36-2.881 7.844-7.61 14.968-5.024 23.747 1.995 4.102 4.58 9.068 8.053 12.666.221-5.038-2.364-16.192-2.364-16.192Z",
    fill: "url(#right_graphic_svg__az)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M75.103 212.685c-4.876-1.511-9.309-2.231-12.855-2.159-3.767 0-8.126-.504-9.234 4.605-1.108 5.11 3.694 25.115 3.62 35.118 6.28 4.318 17.213 2.951 20.833 1.223.443-.287.665-1.151.665-2.374-3.472-3.598-5.984-8.564-8.053-12.666-2.585-8.851 2.217-15.975 5.024-23.747Z",
    fill: "url(#right_graphic_svg__aA)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M75.177 212.829c7.61 1.511 8.126 15.4 11.155 16.119 3.03.72 4.95-6.836 7.166-7.628 1.182-.432 3.916.144 3.399 3.023-.518 2.878-7.314 12.809-12.338 11.154-3.25-1.08-7.83-7.268-10.12-12.018-2.513-5.397-1.7-11.154.738-10.65Z",
    fill: "url(#right_graphic_svg__aB)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m62.47 211.677 1.477-9.211 6.87.432-.812 9.067s-6.058 4.174-7.535-.288Z",
    fill: "#F4A2BA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M59.367 199.3s1.773 6.116 6.132 5.757c2.807-.216 4.802-4.174 4.802-4.174l.886-2.303h1.256l1.109 1.223s.147-5.037 1.108-5.037c2.068.144 1.33-2.375.295-4.174-1.182-1.943-5.097-3.958-8.2-3.958-3.103 0-7.166 2.663-7.61 6.117-.369 3.598.222 6.549.222 6.549Z",
    fill: "#1B2C49"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M61.066 211.245s.296-2.95 1.404-2.734c1.108.216 2.733 3.67 6.501 1.943 1.847-1.152 2.069-.288 2.069-.288l.664 1.583s-2.807 1.727-3.028 2.231c-.591.72-5.246 2.087-6.871-.432 0 0-.96-1.295-.739-2.303Z",
    fill: "url(#right_graphic_svg__aC)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M126.949 208.527c1.661-.933 1.667-3.949.014-6.736-1.654-2.787-4.341-4.29-6.002-3.357-1.662.934-1.668 3.95-.014 6.737s4.341 4.29 6.002 3.356Z",
    fill: "#11A7F6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M123.566 200.811v2.375c0 .216.148.503.37.647.222.144.37 0 .37-.216v-2.374c0-.216-.148-.504-.37-.648-.222-.144-.37 0-.37.216Z",
    fill: "#FFCB29"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M122.31 200.595c-.591.216-1.034.792-1.034 1.799 0 1.655 1.182 3.67 2.659 4.462 1.478.791 2.66.144 2.66-1.511 0-.936-.369-2.015-1.034-2.951-.148-.216-.444-.36-.517-.216-.148.144-.074.432.073.648.444.647.739 1.367.739 2.087 0 .575-.221 1.007-.517 1.223-.369.216-.813.144-1.33-.144-.517-.288-.96-.791-1.329-1.367a3.347 3.347 0 0 1-.518-1.799c0-.648.296-1.152.739-1.295.148-.072.222-.288.074-.576-.222-.288-.443-.432-.665-.36Z",
    fill: "#FFCB29"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M278.264 131.583c2.29 1.295 4.137 4.462 4.137 6.981v.071l1.404.792v-.072c0-3.454-2.512-7.628-5.541-9.355h-.074l.074 1.583c-.074 0-.074 0 0 0Z",
    fill: "#FCAB49"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M282.401 138.707c-.074 2.519-1.921 3.526-4.137 2.231-2.29-1.295-4.137-4.461-4.137-6.98 0-2.591 1.847-3.598 4.137-2.375V130c-3.029-1.727-5.541-.288-5.541 3.166 0 3.454 2.512 7.628 5.541 9.355 3.029 1.727 5.541.36 5.541-3.022l-1.404-.792Z",
    fill: "#fff"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M279.519 155.187c2.956 1.655 5.32 5.613 5.32 8.923v.144l1.773 1.008v-.144c0-4.39-3.177-9.787-7.093-11.946h-.073l.073 2.015c-.073 0-.073 0 0 0Z",
    fill: "#FCAB49"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M284.765 164.254c-.074 3.166-2.438 4.462-5.319 2.879-2.955-1.656-5.319-5.614-5.319-8.924 0-3.238 2.364-4.605 5.245-3.022v-2.015c-3.916-2.159-7.018-.36-7.018 4.03 0 4.389 3.176 9.787 7.092 11.946 3.915 2.158 7.018.431 7.092-3.886l-1.773-1.008Z",
    fill: "#fff"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M228.028 168.212c3.029 1.727 5.54 5.901 5.54 9.355v.144l1.847 1.079v-.144c0-4.605-3.324-10.218-7.387-12.521h-.074l.074 2.087c-.074 0-.074 0 0 0Z",
    fill: "#FCAB49"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M233.568 177.639c-.073 3.31-2.511 4.677-5.54 2.95-3.029-1.727-5.541-5.901-5.541-9.355 0-3.382 2.438-4.821 5.467-3.166v-2.087c-4.063-2.231-7.388-.36-7.388 4.174 0 4.605 3.325 10.218 7.388 12.521 4.063 2.303 7.314.504 7.388-4.03l-1.774-1.007ZM349.186 168.212h-.739c-.222 0-.443-.288-.443-.648v-4.893c0-.36.221-.648.443-.648s.517-.072.739-.072c.222 0 .444.216.444.576v5.037c0 .36-.222.648-.444.648ZM352.141 167.78c-.222.072-.443.144-.665.144-.296.072-.591-.216-.591-.648 0-2.375 0-4.821.074-7.196 0-.432.221-.864.591-.936l.665-.215c.296-.144.591.143.591.575 0 2.447 0 4.894-.074 7.34 0 .432-.221.864-.591.936ZM355.392 166.629a2.22 2.22 0 0 0-.591.288c-.37.143-.666-.144-.666-.648 0-2.951.001-5.901.074-8.923 0-.504.296-1.008.666-1.152.221-.072.369-.216.591-.288.369-.144.665.072.665.576v8.995c-.074.432-.37.936-.739 1.152ZM358.642 164.902c-.148.072-.221.144-.369.215-.444.216-.739 0-.739-.575v-12.881c0-.576.369-1.224.739-1.512.148-.072.221-.144.369-.216.444-.215.739 0 .739.576v12.881c0 .576-.369 1.224-.739 1.512ZM361.819 162.671c-.074 0-.074.072-.148.072-.443.359-.887.072-.887-.576 0-5.685 0-11.298-.074-16.983 0-.648.37-1.439.813-1.727.074 0 .074-.072.148-.072.444-.288.813 0 .813.647 0 5.613.074 11.155.074 16.768.148.719-.295 1.511-.739 1.871ZM365.143 159.936c-.147.072-.221.216-.369.288-.37.36-.739.216-.739-.36 0-5.901-.074-11.73-.074-17.631 0-.575.296-1.223.739-1.511.148-.072.222-.144.37-.216.369-.288.739-.072.739.504 0 5.757.074 11.514.074 17.271 0 .576-.296 1.295-.74 1.655ZM368.098 157.058l-.147.144c-.444.431-.813.287-.813-.288 0-7.197-.074-14.393-.074-21.661 0-.648.369-1.295.813-1.583.074 0 .074-.072.148-.072.443-.288.813 0 .813.648v20.941c.073.575-.296 1.367-.74 1.871Z",
    fill: "#fff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M310.474 178.647c-4.211-.288-8.2-.72-11.894-1.44v2.015c3.694.648 7.683 1.152 11.894 1.439.665.072 1.33.072 1.995.072v-2.015c-.665 0-1.33-.071-1.995-.071ZM310.474 174.689c-4.211-.288-8.2-.72-11.894-1.44v2.015c3.694.648 7.683 1.152 11.894 1.439.665.072 1.33.072 1.995.072v-2.015c-.665 0-1.33-.071-1.995-.071ZM310.474 170.731c-4.211-.288-8.2-.72-11.894-1.44v2.015c3.694.648 7.683 1.152 11.894 1.439.665.072 1.33.072 1.995.072v-2.015c-.665 0-1.33-.071-1.995-.071ZM310.474 150.005c-4.211-.287-8.2-.719-11.894-1.439v2.015c3.694.648 7.683 1.152 11.894 1.439.665.072 1.33.072 1.995.072v-2.015c-.665 0-1.33-.072-1.995-.072ZM310.474 146.048c-4.211-.288-8.2-.72-11.894-1.44v2.015a114.03 114.03 0 0 0 11.894 1.44c.665.072 1.33.072 1.995.072v-2.015c-.665 0-1.33-.072-1.995-.072Z",
    fill: "#fff"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M294.517 258.453c29.172 0 52.822-13.307 52.822-29.721s-23.65-29.72-52.822-29.72c-29.173 0-52.822 13.306-52.822 29.72s23.649 29.721 52.822 29.721Z",
    fill: "url(#right_graphic_svg__aD)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__a",
    x1: 458.918,
    y1: 394.862,
    x2: 150.158,
    y2: 394.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#09BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#16ABFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#3A72F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#504EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#406DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#22A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__b",
    x1: 320.542,
    y1: 303.953,
    x2: 242.059,
    y2: 398.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__c",
    x1: 194.779,
    y1: 331.54,
    x2: 394.206,
    y2: 331.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__d",
    x1: 389.076,
    y1: 300.154,
    x2: 220.714,
    y2: 359.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__f",
    x1: 429.883,
    y1: 405.907,
    x2: 152.253,
    y2: 86.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6929E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B3FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__g",
    x1: 395.999,
    y1: 87.078,
    x2: 174.809,
    y2: 89.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#8969CB",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#9F8AD9",
    stopOpacity: 0.899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#B3A7E4",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#C2BEEE",
    stopOpacity: 0.735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#CED0F5",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#D7DDFA",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#DCE4FD",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#DAE1FC",
    stopOpacity: 0.128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#CFD2F6",
    stopOpacity: 0.284
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#BFB9EC",
    stopOpacity: 0.455
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#A897DE",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#8A6BCC",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#7D57C4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__h",
    x1: 432.928,
    y1: 209.554,
    x2: 161.973,
    y2: 204.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#8969CB",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#9F8AD9",
    stopOpacity: 0.899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#B3A7E4",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#C2BEEE",
    stopOpacity: 0.735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#CED0F5",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#D7DDFA",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#DCE4FD",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#DAE1FC",
    stopOpacity: 0.128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#CFD2F6",
    stopOpacity: 0.284
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#BFB9EC",
    stopOpacity: 0.455
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#A897DE",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#8A6BCC",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#7D57C4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__i",
    x1: 205.081,
    y1: 230.106,
    x2: 383.904,
    y2: 230.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#8969CB",
    stopOpacity: 0.968
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#9F8AD9",
    stopOpacity: 0.899
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#B3A7E4",
    stopOpacity: 0.821
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    stopColor: "#C2BEEE",
    stopOpacity: 0.735
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#CED0F5",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222,
    stopColor: "#D7DDFA",
    stopOpacity: 0.519
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#DCE4FD",
    stopOpacity: 0.362
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#DAE1FC",
    stopOpacity: 0.128
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#CFD2F6",
    stopOpacity: 0.284
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#BFB9EC",
    stopOpacity: 0.455
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.818,
    stopColor: "#A897DE",
    stopOpacity: 0.637
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#8A6BCC",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.965,
    stopColor: "#7D57C4",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__j",
    x1: 258.61,
    y1: 560.747,
    x2: 121.693,
    y2: 560.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#09BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#16ABFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#3A72F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#504EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#406DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#22A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__k",
    x1: 197.248,
    y1: 520.434,
    x2: 162.446,
    y2: 562.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__l",
    x1: 141.48,
    y1: 532.667,
    x2: 229.914,
    y2: 532.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__m",
    x1: 227.639,
    y1: 518.749,
    x2: 152.981,
    y2: 544.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__n",
    x1: 171.43,
    y1: 535.647,
    x2: 199.953,
    y2: 535.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__o",
    x1: 165.105,
    y1: 521.881,
    x2: 206.279,
    y2: 521.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__p",
    x1: 158.78,
    y1: 508.114,
    x2: 212.605,
    y2: 508.114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A57EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__q",
    x1: 152.454,
    y1: 494.347,
    x2: 218.931,
    y2: 494.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4363EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__r",
    x1: 146.129,
    y1: 480.58,
    x2: 225.257,
    y2: 480.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__s",
    x1: 139.803,
    y1: 466.813,
    x2: 231.583,
    y2: 466.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#357AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13B6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__t",
    x1: 133.478,
    y1: 453.046,
    x2: 237.909,
    y2: 453.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D85F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__u",
    x1: 127.153,
    y1: 439.279,
    x2: 244.235,
    y2: 439.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2691F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__v",
    x1: 120.827,
    y1: 425.513,
    x2: 250.561,
    y2: 425.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__w",
    x1: 114.502,
    y1: 411.746,
    x2: 256.887,
    y2: 411.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__x",
    x1: 108.177,
    y1: 397.979,
    x2: 263.213,
    y2: 397.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BBEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__y",
    x1: 530.911,
    y1: 272.387,
    x2: 421.575,
    y2: 272.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#09BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#16ABFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#3A72F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#504EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#406DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#22A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__z",
    x1: 481.91,
    y1: 240.194,
    x2: 454.118,
    y2: 273.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__A",
    x1: 437.375,
    y1: 249.963,
    x2: 507.996,
    y2: 249.963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__B",
    x1: 506.179,
    y1: 238.849,
    x2: 446.56,
    y2: 259.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__C",
    x1: 461.293,
    y1: 252.344,
    x2: 484.07,
    y2: 252.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__D",
    x1: 456.241,
    y1: 241.35,
    x2: 489.122,
    y2: 241.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__E",
    x1: 451.19,
    y1: 230.356,
    x2: 494.173,
    y2: 230.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A57EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__F",
    x1: 446.139,
    y1: 219.362,
    x2: 499.225,
    y2: 219.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4363EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__G",
    x1: 441.088,
    y1: 208.369,
    x2: 504.277,
    y2: 208.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__H",
    x1: 436.037,
    y1: 197.375,
    x2: 509.329,
    y2: 197.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#357AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13B6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__I",
    x1: 430.985,
    y1: 186.381,
    x2: 514.38,
    y2: 186.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D85F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__J",
    x1: 425.934,
    y1: 175.388,
    x2: 519.432,
    y2: 175.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2691F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__K",
    x1: 420.883,
    y1: 164.394,
    x2: 524.484,
    y2: 164.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__L",
    x1: 415.832,
    y1: 153.4,
    x2: 529.535,
    y2: 153.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__M",
    x1: 410.781,
    y1: 142.406,
    x2: 534.587,
    y2: 142.406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BBEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__N",
    x1: 131.269,
    y1: 353.526,
    x2: 17.106,
    y2: 353.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#09BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#16ABFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#3A72F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#504EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#406DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#22A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__O",
    x1: 80.105,
    y1: 319.912,
    x2: 51.086,
    y2: 354.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__P",
    x1: 33.604,
    y1: 330.113,
    x2: 107.342,
    y2: 330.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__Q",
    x1: 105.445,
    y1: 318.508,
    x2: 43.194,
    y2: 340.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__R",
    x1: 58.577,
    y1: 332.598,
    x2: 82.36,
    y2: 332.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__S",
    x1: 53.303,
    y1: 321.119,
    x2: 87.635,
    y2: 321.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__T",
    x1: 48.029,
    y1: 309.64,
    x2: 92.91,
    y2: 309.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A57EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__U",
    x1: 42.755,
    y1: 298.161,
    x2: 98.184,
    y2: 298.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4363EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__V",
    x1: 37.48,
    y1: 286.682,
    x2: 103.459,
    y2: 286.682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__W",
    x1: 32.206,
    y1: 275.203,
    x2: 108.734,
    y2: 275.203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#357AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13B6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__X",
    x1: 26.932,
    y1: 263.724,
    x2: 114.008,
    y2: 263.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D85F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__Y",
    x1: 21.658,
    y1: 252.245,
    x2: 119.283,
    y2: 252.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2691F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__Z",
    x1: 16.384,
    y1: 240.766,
    x2: 124.558,
    y2: 240.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aa",
    x1: 11.11,
    y1: 229.286,
    x2: 129.833,
    y2: 229.286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ab",
    x1: 5.835,
    y1: 217.807,
    x2: 135.107,
    y2: 217.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BBEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ac",
    x1: 550.937,
    y1: 444.113,
    x2: 414.021,
    y2: 444.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#09BFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#16ABFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238,
    stopColor: "#3A72F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#504EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317,
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#406DEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#22A2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ad",
    x1: 489.576,
    y1: 403.8,
    x2: 454.774,
    y2: 445.689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ae",
    x1: 433.807,
    y1: 416.034,
    x2: 522.242,
    y2: 416.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__af",
    x1: 519.967,
    y1: 402.116,
    x2: 445.308,
    y2: 428.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ag",
    x1: 463.758,
    y1: 419.014,
    x2: 492.281,
    y2: 419.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5940E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1BAFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ah",
    x1: 457.433,
    y1: 405.247,
    x2: 498.607,
    y2: 405.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19B0F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ai",
    x1: 451.107,
    y1: 391.48,
    x2: 504.933,
    y2: 391.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A57EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18B2F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aj",
    x1: 444.782,
    y1: 377.713,
    x2: 511.259,
    y2: 377.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4363EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16B3FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ak",
    x1: 438.457,
    y1: 363.947,
    x2: 517.585,
    y2: 363.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C6EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14B5FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__al",
    x1: 432.131,
    y1: 350.18,
    x2: 523.911,
    y2: 350.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#357AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#13B6FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__am",
    x1: 425.806,
    y1: 336.413,
    x2: 530.237,
    y2: 336.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D85F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11B8FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__an",
    x1: 419.481,
    y1: 322.646,
    x2: 536.563,
    y2: 322.646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2691F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ao",
    x1: 413.155,
    y1: 308.879,
    x2: 542.889,
    y2: 308.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F9CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EBBFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ap",
    x1: 406.83,
    y1: 295.112,
    x2: 549.215,
    y2: 295.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18A8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0CBCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aq",
    x1: 400.504,
    y1: 281.345,
    x2: 555.541,
    y2: 281.345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#10B3FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BBEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__at",
    x1: 19.741,
    y1: 284.702,
    x2: 136.712,
    y2: 379.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#8B6CCD",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#A898DE",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#BFBAEC",
    stopOpacity: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#D0D2F6",
    stopOpacity: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#DAE1FC",
    stopOpacity: 0.143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__au",
    x1: 31.598,
    y1: 293.823,
    x2: 119.732,
    y2: 365.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#8B6CCD",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#A898DE",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#BFBAEC",
    stopOpacity: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#D0D2F6",
    stopOpacity: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#DAE1FC",
    stopOpacity: 0.143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__av",
    x1: 41.601,
    y1: 301.518,
    x2: 105.408,
    y2: 353.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D57C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.077,
    stopColor: "#8B6CCD",
    stopOpacity: 0.91
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#A898DE",
    stopOpacity: 0.704
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423,
    stopColor: "#BFBAEC",
    stopOpacity: 0.505
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#D0D2F6",
    stopOpacity: 0.316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#DAE1FC",
    stopOpacity: 0.143
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#DDE6FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aw",
    x1: 54.63,
    y1: 283.991,
    x2: 67.837,
    y2: 283.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA00BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#9001AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#6E039A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#56058C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#470683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ax",
    x1: 61.553,
    y1: 286.86,
    x2: 78.938,
    y2: 286.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA00BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#9001AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#6E039A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.619,
    stopColor: "#56058C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#470683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#420680"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__ay",
    x1: 45.941,
    y1: 212.756,
    x2: 55.127,
    y2: 236.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#F6DDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#F2BBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F0A3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EE94FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__az",
    x1: 45.324,
    y1: 229.606,
    x2: 73.303,
    y2: 230.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#F6DDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#F2BBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F0A3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EE94FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aA",
    x1: 52.863,
    y1: 231.762,
    x2: 78.138,
    y2: 231.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#F6DDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#F2BBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F0A3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EE94FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aB",
    x1: 89.851,
    y1: 216.047,
    x2: 74.326,
    y2: 231.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#F6DDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#F2BBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F0A3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EE94FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8FFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "right_graphic_svg__aC",
    x1: 66.511,
    y1: 208.088,
    x2: 66.296,
    y2: 216.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#F6DDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    stopColor: "#F2BBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#F0A3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#EE94FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8FFC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right_graphic_svg__e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(62.5466 0 0 60.9258 292.802 324.486)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BAFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5940E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right_graphic_svg__ar",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(29.354 -323.877 303.92) scale(28.7852 24.5976)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BAFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5940E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right_graphic_svg__as",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(29.354 -347.911 302.804) scale(19.1816 16.3911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BAFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5940E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "right_graphic_svg__aD",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(187.956 0 0 183.086 381.498 235.556)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BAFF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5940E7"
  })))));
};
export default SvgRightGraphic;